import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";
import { Vehicle } from "../../../models/Vehicle";
import TRACE_API, { baseQuery, reducerPath } from "../../api_client/trace_api";

const tagTypes = ["Vehicle"];

export type VehicleAPIEndpointBuilder = EndpointBuilder<
  typeof baseQuery,
  typeof tagTypes[number],
  typeof reducerPath
>;

const vehicleEndpoints = TRACE_API.injectEndpoints({
  endpoints: (builder: VehicleAPIEndpointBuilder) => ({
    /*
    |---------------------------------------------------------------------
    |                          Vehicle Queries & Mutations
    |---------------------------------------------------------------------
    */

    fetchAllVehicles: builder.query<Vehicle[], void>({
      query: () => ({
        url: "/vehicles",
        method: "GET",
      }),
      providesTags: ["Vehicle"],
    }),

    createVehicle: builder.mutation<void, Vehicle>({
      query(data: any) {
        return {
          url: "/vehicles",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["Vehicle"],
    }),
  }),
  overrideExisting: false,
});

export const { useFetch, useFetchAllVehiclesQuery, useCreateVehicleMutation } =
  vehicleEndpoints;
